import React, { useState, useEffect } from 'react';
import { Row, Col } from 'reactstrap';
import { TabBar, TabsMaster, SearchAdminProgramRequests } from '../../../components/tabs';
import { SearchInstitutionAdminRequests } from '../../../components/academic-affair-program-requests/program-request-search-institution-users';

export const ProgramRequestInstitutionPage = props => {
    const [tabs, setTabs] = useState([
        { id: 'awaitingResponse', label: 'Awaiting Response', count: '' },
        { id: 'submitted', label: 'Submitted', count: '' },
        { id: 'review', label: 'Under Review', count: '' },
        { id: 'approved', label: 'Approved', count: '' },
        { id: 'denied', label: 'Denied', count: '' },
    ]);
    const dataStorage = window.sessionStorage.getItem('programRequestInstitutionTabData')
        ? JSON.parse(window.sessionStorage.getItem('programRequestInstitutionTabData'))
        : null;
    const [tabData, setTabData] = useState(dataStorage ? dataStorage : []);
    const [activeTab, setActiveTab] = useState('awaitingResponse');

    useEffect(() => {
        return () => {
            window.sessionStorage.setItem(
                'programRequestInstitutionTabData',
                JSON.stringify(tabData)
            );
        };
    });
    return (
        <div>
            <TabBar
                tabs={tabs}
                activeTab={activeTab}
                onTabChange={setActiveTab}
                includedButtonText="New Staff Action Request"
            />
            <div className="page-container header-tab-spacer">
                <div className="container-fluid">
                    <Row className="mt-3">
                        <Col className="col-xl-3 col-lg-12 mb-3 mb-lg-0">
                            <SearchInstitutionAdminRequests
                                setTabData={setTabData}
                                setTabHeaders={setTabs}
                                tabHeaders={tabs}
                            />
                        </Col>
                        <Col className="col-xl-9 col-lg-12">
                            <TabsMaster
                                activeTab={activeTab}
                                tabData={tabData}
                            />
                        </Col>
                    </Row>
                </div>
            </div>
        </div>
    );
};
